import { HandySvg } from 'handy-svg';
import iconRightArrow from '../../assets/icons/svg-sprite/arrow-right.svg';
import iconLeftArrow from '../../assets/icons/svg-sprite/arrow-left.svg';
import iconCross from '../../assets/icons/svg-sprite/close-cross.svg';

import { useState, useEffect, useCallback, useRef } from "react";
import { useReactToPrint } from 'react-to-print';
import PrintableCard from '../../components/printableCard/PrintableCard';
import { selects } from '../../lib/select/initSelectize';
import logoTV from '../../assets/images/elems/logo-tv.svg';

import { tv } from '../../lib/api/api';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Print = () => {
    const [channelOptions, setChannelOptions] = useState([]);
    const [dateOptions, setDateOptions] = useState([]);
    const [selectedChannels, setSelectedChannels] = useState([]);
    const [selectedDates, setSelectedDates] = useState([]);
    const [data, setData] = useState([]);
    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef });

    useEffect(() => {
        submitForm();
        tv.tvChannels()
            .then((res) => {
                const array = [];
                res.channels.forEach(item => {
                    array.push({ value: item.id, name: item.name });
                });
                setChannelOptions(array);
            })
            .catch((err) => {
                console.log(err);
            });
        tv.calendar()
            .then((res) => {
                const array = [];
                res.days.forEach(item => {
                    array.push({ value: item.date, name: changeOfDate(item.date) });
                });
                setDateOptions(array);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);
    
    useEffect(() => {
        if (channelOptions.length > 0 && dateOptions.length > 0) {
            selects.tvProgramPrint(channelOptions, dateOptions, changeSelectedChannels, changeSelectedDates);
        }
    }, [channelOptions, dateOptions]);

    useEffect(() => {
        const array = [];
        selectedChannels.forEach(item => {
            selectedDates.forEach(elem => {
                array.push({channel: item, date: elem});
            });
        });
        setData(inThrees(array));
    }, [selectedChannels, selectedDates]);

    function changeOfDate(date) {
        let newDate = '';
        const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
        const index = Number(date.slice(5, 7));
        newDate += `${date.slice(8, 10)} ${months[index - 1]} ${date.slice(11, 16)}`;
        return newDate;
    }

    function inThrees(array) {
        let size = 3;
        let newArray = [];
        for (let i = 0; i < Math.ceil(array.length / size); i++){
            newArray[i] = array.slice((i*size), (i*size) + size);
        }
        return newArray;
    }

    const changeSelectedChannels = useCallback(
        (array) => 
            {
                const channels = [];
                array.forEach(item => {
                    channels.push(item);
                })
                setSelectedChannels(channels);
            },
        [],
    );

    const changeSelectedDates = useCallback(
        (array) =>
            {
                const dates = [];
                array.forEach(item => {
                    dates.push(item);
                })
                setSelectedDates(dates);
            },
        [],
    );

    function submitForm() {
        const formElement = document.getElementById('print-action-form')
        formElement.addEventListener('submit', (e) => {
            e.preventDefault();
        });
    }

    return (
        <>
            <div className="modal-print" id="modal-print">
                <div className="content">
                    <div className="tv-program-print">
                        <div className="tv-program-print__header">
                            <div className="tv-program-print__wrap-title">
                                <div className="tv-program-print__title title title--h3">Печать телепрограммы</div>
                                <a className="tv-program-print__close" href="javascript:void(0)">
                                    <HandySvg className="svg-icon" src={iconCross} width="18" height="18"/>
                                </a>
                            </div>
                            <div className="tv-program-print__choose">
                                <form id="print-action-form" className="tv-program-print__choose-form">
                                    <div className="tv-program-print__choose-item">
                                        <div className="tv-program-print__choose-title">Телеканалы:</div>
                                        <div className="multiple-select select js-select select--lg multiple-select js-modal-program-multiple-select" style={{width: '460px'}}>
                                            <div className="selectize-close"></div>
                                            <select className="multiple-select__item select__item" id="print-channels" placeholder="Выберите каналы"/>
                                        </div>
                                    </div>
                                    <div className="tv-program-print__choose-item">
                                        <div className="tv-program-print__choose-title">Дни:</div>
                                        <div className="multiple-select select js-select select--lg multiple-select js-modal-program-multiple-select" style={{width: '460px'}}>
                                            <div className="selectize-close"></div>
                                            <select className="multiple-select__item select__item" id="print-dates" placeholder="Выберите дни"/>
                                        </div>
                                    </div>
                                    <button onClick={reactToPrintFn} className="bttn tv-program-print__choose-btn" type="submit" value="Печать">Печатать</button>
                                </form>
                            </div>
                        </div>
                        <div className="tv-program-print__list">
                            <div className="tv-program-print__list-header">
                                <div className="tv-program-print__list-header-logo">
                                    <img src={logoTV}/>
                                </div>
                                <div className="tv-program-print__list-header-state">
                                    <div className="tv-program-print__list-header-wrap-button">
                                        <button className="tv-program-print__list-header-btn tv-program-print__list-header-btn--prev">
                                            <HandySvg className="svg-icon" src={iconLeftArrow} width="20" height="20"/>
                                        </button>
                                        <button className="tv-program-print__list-header-btn tv-program-print__list-header-btn--next">
                                            <HandySvg className="svg-icon" src={iconRightArrow} width="20" height="20"/>
                                        </button>
                                    </div>
                                    <div className="tv-program-print__list-header-pages">стр.&nbsp;<span className="tv-program-print-pagination"></span></div>
                                </div>
                            </div>
                            <div className="tv-program-print__slider">
                                <Swiper
                                    modules={[Navigation, Pagination]}
                                    className='tv-program-print__slider-content'
                                    pagination={{
                                        type: 'fraction',
                                        el: '.tv-program-print-pagination',
                                    }}
                                    navigation={{
                                        prevEl: '.tv-program-print__list-header-btn--prev',
                                        nextEl: '.tv-program-print__list-header-btn--next',
                                    }}
                                >
                                    {data.map(item => (
                                        <SwiperSlide className="tv-program-print__slider-item">
                                            {item.map(elem => (
                                                <PrintableCard channel={elem.channel} date={elem.date}/>
                                            ))}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                            <div style={{ display: 'none' }}>
                                <div class="print-tv-program" ref={contentRef}>
                                    <div class="print-tv-program__list">
                                        <div class="print-tv-program__list-item">
                                            {data.map(item => (
                                                item.map(elem => (
                                                    <PrintableCard channel={elem.channel} date={elem.date}/>
                                                ))
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Print;